module.exports = "<div #modalContainer></div>\n<div class=\"toast-container\">\n  <div #toastContainer></div>\n</div>\n"